/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

export function TextArea(props) {
  const { em } = props;
  // const { parentSize } = em;
  const parentSize = em.parentSize || (props.parent && props.parent.size) || 'half';
  const floating = em.floating;
  const groupClass = (floating ? '' : 'row') + ' ' + (em && em.class ? em.class : '');
  const labelClass = floating ? 'label' : `col-sm-${parentSize === 'full' ? '2' : '5'} col-form-label`;
  const inputClass = floating ? '' : `col-sm-${parentSize === 'full' ? '10' : '7'}`;

  const handleDefaultChange = useCallback((e) => {
    console.info(e);
  }, []);

  const inputProperty = {};
  if (props.data && em && em.field) {
    inputProperty.value = (props.data && em && em.field && props.data[em.field]) || '';
  }

  if (props.onChange) {
    inputProperty.onChange = props.onChange || handleDefaultChange;
  }

  return (
    <div className={`form-group ${groupClass}`}>
      <label className={`${labelClass}`}>{em.label}</label>
      <textarea
        type="text"
        className={`form-control ${inputClass}`}
        name={(em && em.field) || em.name}
        rows={em.rows}
        // value={(props.data && props.data[em.field]) || ''}
        placeholder={em.placeholder}
        onKeyDown={em.onKeyDown}
        readOnly={em.readOnly}
        // onChange={props.onChange || handleDefaultChange}
        {...inputProperty}
      ></textarea>
    </div>
  );
}

TextArea.defaultProps = {
  em: {}, // parentSize: 'half'
};

TextArea.propTypes = {
  app : PropTypes.any, 
  em : PropTypes.any, 
  data: PropTypes.any,
  parent: PropTypes.any,
  onChange: PropTypes.func,
}